import { useL2rQuery } from "@l2r-front/l2r-query"

export function usePhotoQuery(
    url,
    queryKey,
    queryParameters,
    config = {},
    initialData,
) {
    const apiUrl = `photo/${url}`

    return useL2rQuery(
        apiUrl,
        queryKey,
        queryParameters,
        config,
        initialData,
    )
}